import { render } from "./PartnerSettings.vue?vue&type=template&id=7a94c8e3&scoped=true"
import script from "./PartnerSettings.vue?vue&type=script&lang=js"
export * from "./PartnerSettings.vue?vue&type=script&lang=js"

import "./PartnerSettings.vue?vue&type=style&index=0&id=7a94c8e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a94c8e3"]])

export default __exports__